const OWNLIST = '/accounting/ownCheck/list'
const THIRDPARTYLIST = '/accounting/thirPartyCheck/list'

export const accountingCheckEndpoints = {
  OWNLIST,
  THIRDPARTYLIST,
}
